import { jsxs, jsx } from "react/jsx-runtime";
import assert from "assert";
import "../ThemeProvider/ThemeProvider.mjs";
import "../ThemePortal/ThemePortal.mjs";
import "../Text/TextContext.mjs";
import "../ThemeProvider/ThemeContext.mjs";
import "../ThemeProvider/VanillaThemeContainer.mjs";
import "../private/DefaultMessagesContext.mjs";
import "../ThemeProvider/BreakpointContext.mjs";
import "../../css/atoms/sprinkles.css.mjs";
import { PublicBox } from "../Box/Box.mjs";
import { Stack } from "../Stack/Stack.mjs";
import "../Box/BackgroundContext.mjs";
import "../Divider/Divider.css.mjs";
import "../Accordion/AccordionContext.mjs";
import { Text } from "../Text/Text.mjs";
import { Columns } from "../Columns/Columns.mjs";
import { Column } from "../Column/Column.mjs";
import { Inline } from "../Inline/Inline.mjs";
import "../Heading/HeadingContext.mjs";
import "../../css/lineHeightContainer.css.mjs";
import "../../css/reset/reset.css.mjs";
import "../../hooks/useIcon/icon.css.mjs";
import "../../css/typography.css.mjs";
import "../private/touchable/virtualTouchable.css.mjs";
import "../private/hideFocusRings/hideFocusRings.css.mjs";
import "../Accordion/AccordionItem.css.mjs";
import "../Actions/ActionsContext.mjs";
import "../../css/textAlignedToIcon.css.mjs";
import "../Alert/Alert.css.mjs";
import "../Autosuggest/Autosuggest.mjs";
import "../Avatar/Avatar.css.mjs";
import { Badge } from "../Badge/Badge.mjs";
import "../../css/negativeMargin/negativeMargin.css.mjs";
import "../Breadcrumb/Breadcrumb.css.mjs";
import "../Box/ColoredBox.mjs";
import "../Button/Button.mjs";
import "../ButtonIcon/ButtonIcon.mjs";
import "../ButtonLink/ButtonLink.mjs";
import "../private/Keyline/Keyline.css.mjs";
import "../Checkbox/Checkbox.mjs";
import { CheckboxStandalone } from "../Checkbox/CheckboxStandalone.mjs";
import "../ContentBlock/ContentBlock.css.mjs";
import "../DateField/DateField.mjs";
import "../private/Field/FloatingLabel.css.mjs";
import "../private/Field/Field.css.mjs";
import "../DateField/DateField.css.mjs";
import "../private/Modal/Modal.mjs";
import "../private/Modal/ModalContent.mjs";
import "../private/Modal/ModalContext.mjs";
import "../TextLink/TextLink.mjs";
import "../TextLinkButton/TextLinkButton.css.mjs";
import "../private/AvoidWidowIcon/AvoidWidowIcon.css.mjs";
import "../Dropdown/Dropdown.mjs";
import "../private/MaxLines/MaxLines.css.mjs";
import { Hidden } from "../Hidden/Hidden.mjs";
import "../HiddenVisually/HiddenVisually.css.mjs";
import "../Link/Link.mjs";
import "../private/defaultTextProps.mjs";
import "../List/List.css.mjs";
import "../Loader/Loader.css.mjs";
import "../Skeleton/Skeleton.css.mjs";
import "../MenuRenderer/MenuRenderer.mjs";
import "../MenuItem/MenuItem.mjs";
import "../MenuItemCheckbox/MenuItemCheckbox.mjs";
import "../MenuItemDivider/MenuItemDivider.mjs";
import "../MenuItem/MenuItemLink.mjs";
import "../OverflowMenu/OverflowMenu.css.mjs";
import "../MonthPicker/MonthPicker.mjs";
import "../Pagination/Pagination.css.mjs";
import "../PasswordField/PasswordField.mjs";
import "../Pincode/Pincode.mjs";
import "../PopoverRenderer/PopoverRenderer.mjs";
import "../Pressable/Pressable.mjs";
import "../RadioGroup/RadioGroup.mjs";
import "../RadioGroup/RadioItem.mjs";
import "../RadioGroup/RadioItemBlock.mjs";
import { labelText } from "./SelectableList.css.mjs";
import "../private/BulkActions/BulkActions.css.mjs";
import "../Spread/Spread.css.mjs";
import "../Stepper/Step.mjs";
import "../Stepper/Stepper.mjs";
import "../Tabs/Tab.mjs";
import "../Table/Table.mjs";
import "../Table/Table.css.mjs";
import "../Tabs/TabsProvider.mjs";
import "../Tabs/TabListContext.mjs";
import "../Tabs/Tabs.css.mjs";
import "../Tabs/TabPanelsContext.mjs";
import "../Tag/Tag.css.mjs";
import "../Textarea/Textarea.mjs";
import "../TextDropdown/TextDropdown.css.mjs";
import "../TextField/TextField.mjs";
import "../Tiles/Tiles.css.mjs";
import "../Toggle/Toggle.mjs";
import "../useToast/ToastContext.mjs";
import "../TooltipRenderer/TooltipRenderer.mjs";
import "../TimeField/DateSegment.css.mjs";
import "../private/FieldButtonIcon/FieldButtonIcon.mjs";
import "../MultiStepModal/MultiStepModal.mjs";
import "../SearchField/SearchField.mjs";
import "../RadioBar/RadioBarContext.mjs";
import "../RadioBar/RadioBar.css.mjs";
import "../../themes/vars.css.mjs";
import "../RadioBar/RadioBar.mjs";
const ListItem = ({
  id,
  label,
  icon,
  description,
  badges,
  disabled,
  tone = "neutral",
  selected,
  onSelect
}) => {
  if (badges == null ? void 0 : badges.length) {
    assert((badges == null ? void 0 : badges.length) <= 2, "Max number of badges is 2");
  }
  return /* @__PURE__ */ jsxs(Columns, { space: "none", collapseBelow: "tablet", children: [
    /* @__PURE__ */ jsx(Column, { children: /* @__PURE__ */ jsxs(PublicBox, { display: "flex", alignItems: "center", gap: "gutter", children: [
      /* @__PURE__ */ jsx(
        CheckboxStandalone,
        {
          id,
          disabled,
          tone,
          checked: selected,
          onChange: onSelect,
          "aria-label": label,
          value: id
        }
      ),
      /* @__PURE__ */ jsxs(Stack, { space: "xsmall", children: [
        /* @__PURE__ */ jsxs(Inline, { space: "xxsmall", alignY: "center", children: [
          /* @__PURE__ */ jsx(PublicBox, { className: labelText, flexWrap: "wrap", children: /* @__PURE__ */ jsx(Text, { size: "standard", weight: "strong", tone: disabled ? "disabled" : void 0, children: label }) }),
          icon
        ] }),
        /* @__PURE__ */ jsx(Text, { size: "small", tone: disabled ? "disabled" : void 0, children: description })
      ] })
    ] }) }),
    /* @__PURE__ */ jsxs(Column, { width: "content", children: [
      /* @__PURE__ */ jsx(Hidden, { below: "tablet", children: /* @__PURE__ */ jsx(Stack, { space: "xsmall", children: badges == null ? void 0 : badges.map((item, index) => /* @__PURE__ */ jsx(Badge, { tone: item.tone, weight: item.weight ?? "regular", children: item.label }, index)) }) }),
      /* @__PURE__ */ jsx(Hidden, { above: "mobile", children: badges && badges.length > 0 && /* @__PURE__ */ jsx(PublicBox, { marginLeft: "xlarge", marginTop: "xsmall", children: /* @__PURE__ */ jsx(Inline, { space: "xsmall", children: badges.map((item, index) => /* @__PURE__ */ jsx(Badge, { tone: item.tone, weight: item.weight ?? "regular", children: item.label }, index)) }) }) })
    ] })
  ] });
};
export {
  ListItem
};
